import axios from 'axios';
import { backendURL } from './consts';

export const getAttendeeOtp = async (userData) => {
  const res = await axios.post(`${backendURL}/attendee/getOTP`, userData);
  return res.data;
}

export const submitAttendeeOtp = async (data) => {
  const res = await axios.post(`${backendURL}/attendee/checkOTP`, data);
  return res.data;
}

export const checkId = async (data) => {
  const res = await axios.post(`${backendURL}/attendee/checkId`, data);
  return res.data;
}

